import React from 'react';

const Title = () => {
    return (
        <div className="title">
        <h1>PhotoGram</h1>
        <h2>Photo Portfolio</h2>
        <p>A grid-based photo gallery web app created using create-react-app, google firebase, and framer motion library.</p>
        </div>
    )
}

export default Title;